import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import owlLogo from '../Assets/logo icon transparent background.png';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-bold text-[#1d2840] mb-3">{title}</h2>
    <div className="text-gray-600 space-y-2">{children}</div>
  </div>
);

const BulletList = ({ items }) => (
  <ul className="list-none space-y-2 mt-2">
    {items.map((item, index) => (
      <li key={index} className="flex items-start">
        <span className="text-[#3DA3DC] mr-2">•</span>
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Header */}
      <div className="w-full bg-white shadow-sm sticky top-0 z-50">
        <header className="container mx-auto px-4 flex justify-between items-center py-5">
          <Link to="/" className="flex items-center">
            <img src={owlLogo} alt="SuperOwl Logo" className="h-14 md:h-16 mr-3" />
            <span className="text-[#1d2840] text-2xl md:text-3xl font-bold">Super</span>
            <span className="text-[#3DA3DC] text-2xl md:text-3xl font-bold">Owl</span>
          </Link>
        </header>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-[#1d2840] mb-4">Privacy Policy</h1>
          <p className="text-gray-500 mb-8">Effective Date: 10-03-2025</p>

          <p className="text-gray-600 mb-8">
            Welcome to SuperOwl, a service provided by Beaut Group. Your privacy is important to us, and we are committed 
            to protecting your personal data. This Privacy Policy outlines how we collect, use, and protect your information 
            when you use our AI conversational chat services.
          </p>

          <div className="space-y-8">
            <Section title="1. Information We Collect">
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold mb-2">A. Personal Information</h3>
                  <BulletList items={[
                    'Name, email address, and contact details when you register or communicate with us.',
                    'Business details if you are using SuperOwl for commercial purposes.'
                  ]} />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">B. Usage & Technical Information</h3>
                  <BulletList items={[
                    'Chat interactions with our AI, including messages and responses.',
                    'Device information, IP address, browser type, and usage analytics.',
                    'Cookies and tracking technologies to enhance user experience.'
                  ]} />
                </div>
              </div>
            </Section>

            {/* Add remaining sections similarly */}
            {/* ...existing sections... */}

            <Section title="8. Contact Us">
              <p>If you have any questions or concerns about this Privacy Policy, please reach out to us:</p>
              <div className="mt-2 space-y-1">
                <p className="flex items-center">
                  <span className="mr-2">📧</span>
                  beautgroup@gmail.com
                </p>
                <p className="flex items-start">
                  <span className="mr-2">📍</span>
                  #5/1 First Floor, New Thippasandra, HAL 3rd Stage, Bangalore - 560075
                </p>
              </div>
            </Section>
          </div>

          <p className="mt-12 text-gray-600 text-center">
            By using SuperOwl, you acknowledge that you have read, understood, and agree to this Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
